<template>
  <div class="habilitados">
    <div class="row">
      <div class="col-xs-12">
        <button
          type="button"
          class="btn btn-primary btn-voltar"
          @click="$router.back()"
        >
          <font-awesome-icon :icon="'arrow-left'" />
          Voltar
        </button>
        <h2 class="page-header">Habilitados</h2>
        <h3>
          Edital nº {{ edital.numero }} - Processo nº
          {{ edital.processo_numero }}
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <data-table
          ref="vuetable"
          :title="'Lista de Cargos'"
          :dados="cargos"
          :fields="fields"
          :carregando="isLoading"
        >
        </data-table>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <h3 id="cabecalho_habilitados">Importar Habilitados</h3>
      </div>
      <div class="col-xs-12 form-group">
        <button @click="baixarPlanilhaBase()" class="btn btn-default">
          <font-awesome-icon :icon="'file-download'" /> Baixar CSV base
        </button>
      </div>
      <div class="col-xs-12">
        <div class="form-group">
          <label class="" for="input-file-import">Upload CSV Habilitados</label>
          <input
            type="file"
            class="form-control"
            :class="{ ' is-invalid': error.message }"
            id="input-file-import"
            name="file_import"
            accept=".csv"
            ref="import_file"
            @change="onFileChange"
          />
        </div>
        <div v-if="error.message" class="invalid-feedback"></div>
        <div class="form-group">
          <button
            class="btn btn-default"
            @click="proceedAction"
            :disabled="!this.import_file || isLoading"
          >
            <font-awesome-icon v-if="isLoading" :icon="'spinner'" spin />
            <font-awesome-icon v-else :icon="'save'" />
            Enviar
          </button>
        </div>
      </div>
      <div class="col-xs-12">
        <h3>
          Lista de Habilitados -
          <button
            title="Excluir Todos"
            class="btn btn-default"
            @click="excluir({ id: 0, geral: 1, pcd: 0, cotas: 0 })"
            :disabled="!habilitados.length || isLoading"
          >
            <font-awesome-icon v-if="isLoading" :icon="'spinner'" spin />
            <font-awesome-icon v-else :icon="'trash-alt'" />
            <span class="sr-only">Excluir todos habilitados</span>
          </button>
        </h3>
        <data-table
          ref="vuetable_habilitados"
          id="vuetable_habilitados"
          :title="'Lista de Habilitados'"
          :dados="habilitados"
          :fields="fields_habilitados"
          :carregando="isLoading"
        >
          <template slot="rowrender" slot-scope="props">
            <button
              class="btn btn-danger"
              @click="excluir(props.rowData)"
              :disabled="isLoading"
            >
              <font-awesome-icon v-if="isLoading" :icon="'spinner'" spin />
              <font-awesome-icon v-else :icon="'trash-alt'" />
              <span class="sr-only">Excluir</span>
            </button>
          </template>
        </data-table>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <h3>
          Lista de Habilitados PCD -
          <button
            title="Excluir Todos"
            class="btn btn-default"
            @click="excluir({ id: 0, geral: 0, pcd: 1, cotas: 0 })"
            :disabled="!habilitados_pcd.length || isLoading"
          >
            <font-awesome-icon v-if="isLoading" :icon="'spinner'" spin />
            <font-awesome-icon v-else :icon="'trash-alt'" />
            <span class="sr-only">Excluir todos habilitados</span>
          </button>
        </h3>
        <data-table
          ref="vuetable_habilitados_pcd"
          id="vuetable_habilitados_pcd"
          :title="'Lista de Habilitados - PCD'"
          :dados="habilitados_pcd"
          :fields="fields_habilitados"
          :carregando="isLoading"
        >
          <template slot="rowrender" slot-scope="props">
            <button
              class="btn btn-danger"
              @click="excluir(props.rowData)"
              :disabled="isLoading"
            >
              <font-awesome-icon v-if="isLoading" :icon="'spinner'" spin />
              <font-awesome-icon v-else :icon="'trash-alt'" />
              <span class="sr-only">Excluir</span>
            </button>
          </template>
        </data-table>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <h3>
          Lista de Habilitados Negros -
          <button
            title="Excluir Todos"
            class="btn btn-default"
            @click="excluir({ id: 0, geral: 0, pcd: 0, cotas: 1 })"
            :disabled="!habilitados_cotas.length || isLoading"
          >
            <font-awesome-icon v-if="isLoading" :icon="'spinner'" spin />
            <font-awesome-icon v-else :icon="'trash-alt'" />
            <span class="sr-only">Excluir todos habilitados</span>
          </button>
        </h3>
        <data-table
          ref="vuetable_habilitados_cotas"
          id="vuetable_habilitados_cotas"
          :title="'Lista de Habilitados - Negros'"
          :dados="habilitados_cotas"
          :fields="fields_habilitados"
          :carregando="isLoading"
        >
          <template slot="rowrender" slot-scope="props">
            <button
              class="btn btn-danger"
              @click="excluir(props.rowData)"
              :disabled="isLoading"
            >
              <font-awesome-icon v-if="isLoading" :icon="'spinner'" spin />
              <font-awesome-icon v-else :icon="'trash-alt'" />
              <span class="sr-only">Excluir</span>
            </button>
          </template>
        </data-table>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '@/request'
import DataTable from '@/components/common/NoApiTable'

export default {
  inject: ['showConfirm'],
  components: { DataTable },
  data() {
    return {
      error: {},
      import_file: '',
      isLoading: false,
      edital: {},
      cargos: [],
      habilitados: [],
      habilitados_pcd: [],
      habilitados_cotas: [],
      fields: [
        {
          name: 'descricao',
          title: 'Descrição'
        },
        {
          name: 'vagas',
          title: 'Vagas',
          titleClass: 'text-right',
          dataClass: 'text-right'
        },
        {
          name: 'vagas_pcd',
          title: 'Vagas PCD',
          titleClass: 'text-right',
          dataClass: 'text-right'
        },
        {
          name: 'vagas_cotas',
          title: 'Vagas Negros',
          titleClass: 'text-right',
          dataClass: 'text-right'
        },
        {
          name: 'vagas_QP',
          title: 'Vagas QP',
          titleClass: 'text-right',
          dataClass: 'text-right'
        }
      ],
      fields_habilitados: [
        {
          name: 'classificacao',
          title: 'Classificação',
          dataClass: 'text-right'
        },
        {
          name: 'descricao',
          title: 'Cargo'
        },
        {
          name: 'nome',
          title: 'Nome'
        },
        {
          name: 'tipo_normal',
          title: 'Geral',
          titleClass: 'text-center',
          dataClass: 'text-center',
          callback: value => {
            return value === 1 ? 'Sim' : 'Não'
          }
        },
        {
          name: 'tipo_pcd',
          title: 'PCD',
          titleClass: 'text-center',
          dataClass: 'text-center',
          callback: value => {
            return value === 1 ? 'Sim' : 'Não'
          }
        },
        {
          name: 'tipo_cotas',
          title: 'Negro',
          titleClass: 'text-center',
          dataClass: 'text-center',
          callback: value => {
            return value === 1 ? 'Sim' : 'Não'
          }
        },
        {
          name: '__slot:actions',
          title: 'Excluir',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }
      ]
    }
  },
  created() {
    if (_.isEmpty(this.$route.params)) {
      this.$router.push({ name: 'editais' })
    } else {
      this.edital = { ...this.$route.params.edital }
      this.listarCargosEdital()
      this.listarHabilitadosEdital()
    }
  },
  methods: {
    baixarPlanilhaBase() {
      request
        .get('habilitado/download-planilha-base', {
          responseType: 'arraybuffer'
        })
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/csv' })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'planilha-base.csv'
          link.click()
        })
    },
    excluir(props) {
      const { id, geral, pcd, cotas } = props
      const config = {
        title: 'Alerta',
        question: true,
        yes: () => {
          request
            .delete(`habilitado/${id}`, {
              params: { geral, pcd, cotas, edital_id: this.edital.id }
            })
            .then(response => {
              this.$toastr.s('Candidato habilitado excluído com sucesso')
              this.listarHabilitadosEdital()
            })
            .catch(error => {
              this.$toastr.e(
                'Houve um erro ao excluir o candidato habilitado, tente novamente e, se persistir o erro, entre em contato com o administrador.'
              )
            })
        }
      }
      this.showConfirm(
        'Deseja realmente excluir este candidato habilitado?',
        config
      )
    },
    onFileChange(e) {
      this.import_file = e.target.files[0]
    },
    proceedAction() {
      if (!this.import_file) {
        this.$toastr.e('Arquivo de importação não encontrado!')
        return
      }
      this.handleLoading()
      let formData = new FormData()
      formData.append('import_file', this.import_file)
      formData.append('cargos', JSON.stringify(this.cargos))

      request
        .post('/habilitado', formData, {
          headers: { 'content-type': 'multipart/form-data' }
        })
        .then(response => {
          const { msg } = response.data
          this.$toastr.s(msg)
          this.listarHabilitadosEdital()
        })
        .catch(error => {
          const { data } = error.response
          this.$toastr.e(data.message)
          this.error = error.response.data
          console.log('check error: ', this.error)
        })
        .finally(this.handleLoading)
    },
    scrollToElement(refName) {
      let element = document.getElementById(refName)
      element.scrollIntoView({ behavior: 'smooth' })
    },
    listarCargosEdital() {
      request
        .get('cargo', { params: { nr_edital: this.edital.numero } })
        .then(response => {
          const { data } = response
          this.cargos = data
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    filter: key => item => item[key] === 1,
    listarHabilitadosEdital() {
      this.handleLoading()
      request
        .get('habilitado', { params: { edital_id: this.edital.id } })
        .then(response => {
          const { data } = response
          this.habilitados = data.filter(this.filter('tipo_normal'))
          this.habilitados_pcd = data.filter(this.filter('tipo_pcd'))
          this.habilitados_cotas = data.filter(this.filter('tipo_cotas'))
        })
        .catch(error => console.log(error.response))
        .finally(this.handleLoading)
    },
    handleLoading() {
      this.isLoading = !this.isLoading
    }
  }
}
</script>

<style scoped>
.btn-voltar {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/concursos/edital/Habilitados.vue